import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild
} from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IfFeatureService } from '../../../services/if-feature/if-feature.service';
import { MenuService } from '../../../services/menu/menu.service';
import { MobileFlyoutMenuNavComponent } from './mobile-flyout-menu-nav.component';

@Component({
  selector: 'td-wb-mobile-flyout-menu',
  templateUrl: 'mobile-flyout-menu.component.html',
  styleUrls: ['mobile-flyout-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileFlyoutMenuComponent implements OnChanges, OnDestroy {

  @Output() readonly openedChange: EventEmitter<boolean> = new EventEmitter<boolean>(true);

  @Input()
  get opened(): boolean { return this._opened; }

  @ViewChild('test') testElement: ElementRef;

  @ContentChildren(MobileFlyoutMenuNavComponent, {
    descendants: true
  })
    menus: QueryList<MobileFlyoutMenuNavComponent>;

  @Input() mainNav: MobileFlyoutMenuNavComponent;

  @HostBinding('class.td-wb-mobile-flyout-menu--show')
  get menuVisible(): boolean { return this._opened; }

  @HostBinding('style.display')
  get menuDisplay(): string { return this._opened ? 'block' : 'none'; }

  @HostBinding('style.width')
  get menuWidth(): string { return this._opened ? '100%' : '0'; }

  private _opened: boolean = false;
  private chatFeatureEnabled: boolean = false;
  private readonly destroy: Subject<void> = new Subject<void>();

  constructor(private changeDetectorRef: ChangeDetectorRef,
              private menuService: MenuService,
              private ifFeatureService: IfFeatureService) {
    this.chatFeatureEnabled = this.ifFeatureService.getFeatureFlag('wbrChatEnabled');
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (event.target['closest'] !== undefined &&
        event.target['closest']('.td-wb-mobile-flyout-menu--show a[href]') !== null) {
      this.close();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mainNav !== undefined && changes.mainNav.currentValue !== undefined) {
      this.mainNav.openedChange
        .pipe(
          takeUntil(this.destroy)
        )
        .subscribe((opened: boolean): void => {
          if (opened) {
            this.open();
          } else {
            this.close();
          }
          this.changeDetectorRef.markForCheck();
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  open(): void {
    this.toggle(true);
    if (this.chatFeatureEnabled) {
      this.menuService.hideFabMenuForMobileMenu();
    }
    this.mainNav.open();
  }

  close(): void {
    this.toggle(false);
    if (this.chatFeatureEnabled) {
      this.menuService.showFabMenuForMobileMenu();
    }
    this.menus.forEach((m: MobileFlyoutMenuNavComponent): void => m.close());
  }

  toggle(isOpen: boolean = !this.opened): void {
    if (this._opened !== isOpen) {
      this._opened = isOpen;
      this.openedChange.emit(this._opened);
    }
  }

  onBackdropClicked(): void {
    this.close();
  }
}
